<div
  class="view-column"
  [ngClass]="{
    'view-column--unpadded': unpadded,
    'view-column--left': placement === 'left',
    'view-column--right': placement === 'right'
  }"
  #viewColumn>
  <div class="view-column__inner">
    <div class="view-column__header" >
      <ng-content select="[view-column-header]"></ng-content>
    </div>

    <div class="view-column__body">
      <ng-content></ng-content>
    </div>
  </div>
</div>